import * as React from 'react'
import moment from 'moment'

import { EventModel } from '@/app/models/newDelegation/eventModel'
import { TripEventType } from '@/app/constants/delegation/tripEventType'
import { getEventTypeIcon } from '@/app/common/converters/newDelegation/tripEventTypeToIconConverter'
import { getTripEventTypeName } from '@/app/common/converters/newDelegation/tripEventTypeToTextConverter'
import { getCountryFlag } from '@/app/services/country/countryFlagResolver'
import { FaIcon } from '@/lib/fa'
import Tooltip from '@/modules/drivers/shared/ToolTip'
import {
  MARKER_BOX_WIDTH,
  MARKER_LANE_STEP,
} from '@/modules/drivers/tabs/activities/components_new/layers/pointLanes'
import {
  BOTTOM_PADDING,
  SCENE_HEIGHT,
} from '@/modules/drivers/tabs/activities/components_new/utils/layout'

export const MARKER_VISUAL_HEIGHT = SCENE_HEIGHT - BOTTOM_PADDING
export const MARKER_VISUAL_WIDTH = MARKER_BOX_WIDTH

type DelegationMarkerVisualProps = {
  marker: EventModel
  translate: (text: string) => any
  lane?: number
  time?: string
  onActivate?: () => void
}

const formatTime = (marker: EventModel, time?: string): string => {
  if (typeof time === 'string' && time.length > 0) {
    const [hours, minutes] = time.split(':')
    return minutes != null ? `${hours}:${minutes}` : time
  }
  if (!marker?.date) return ''
  const value = moment(marker.date as any)
  return value.isValid() ? value.format('HH:mm') : ''
}

const DelegationMarkerVisual: React.FC<DelegationMarkerVisualProps> = ({
  marker,
  translate,
  lane = 0,
  time,
  onActivate,
}) => {
  const icon = getEventTypeIcon(marker.tripEvent)
  const showFlag =
    marker.tripEvent === TripEventType.ChangeCountry && !!marker.country?.code
  const clickable = onActivate != null


  const pinProps = clickable
    ? {
        onClick: onActivate,
        style: { pointerEvents: 'auto' as const },
        className:
          'tw-flex tw-h-full tw-flex-col tw-items-center tw-justify-start tw-cursor-pointer tw-rounded-sm hover:tw-bg-[#1f2937]/20',
      }
    : {
        className:
          'tw-flex tw-h-full tw-flex-col tw-items-center tw-justify-start',
      }

  const head = (
    <div className="tw-rounded-sm">
      {showFlag ? (
        <div className="tw-grid tw-h-6 tw-w-6 tw-place-items-center">
          <img
            src={getCountryFlag(
              marker.country!.code.toUpperCase() === 'GB'
                ? 'EN'
                : marker.country!.code,
            )}
            width={20}
            height={15}
          />
        </div>
      ) : (
        <div className="tw-grid tw-h-6 tw-w-6 tw-place-items-center tw-rounded-full tw-border tw-border-primary tw-bg-primary tw-shadow-sm">
          {icon && (
            <FaIcon className="tw-h-3 tw-w-3 tw-text-white" icon={icon} />
          )}
        </div>
      )}
    </div>
  )

  return (
    <div
      className="tw-h-full"
      style={{
        width: MARKER_VISUAL_WIDTH,
        paddingTop: lane * MARKER_LANE_STEP,
      }}
    >
      <div {...pinProps}>
        {clickable ? (
          <Tooltip
            text={getTripEventTypeName(marker.tripEvent, translate)}
            asChild
          >
            {head}
          </Tooltip>
        ) : (
          head
        )}

        <div className="tw-flex tw-w-[8px] tw-flex-1 tw-justify-center">
          <div className="tw-h-full tw-w-[1px] tw-bg-primary" />
        </div>

        <div className="tw-grid tw-place-items-center tw-rounded tw-bg-primary tw-px-0.5 tw-py-[1px]">
          <span className="tw-text-[10px] tw-font-medium tw-text-base-100">
            {formatTime(marker, time)}
          </span>
        </div>
      </div>
    </div>
  )
}

export default DelegationMarkerVisual
